import "./sparklineCellRenderer.scss";
import Highcharts from "highcharts/highstock";
import annotationsModule from "highcharts/modules/annotations";
import React, { useMemo } from "react";
import { formatLabel } from "./sparkline-cell-renderer-formatter";
import { getExtremes, formatData } from "./sparkline-cell-renderer-helper";
import { InsHighcharts } from "components/widgets/base";
annotationsModule(Highcharts);
const selectFirstHighestAndLowestPeeks = (peeks) => {
    const annotatedPeeks = [];
    if (peeks && peeks[0]) {
        let [highestPeek] = peeks, [lowestPeek] = peeks;
        if (highestPeek && lowestPeek) {
            peeks.forEach((peek) => {
                if (peek) {
                    if (peek.y && highestPeek.y && peek.y > highestPeek.y) {
                        highestPeek = peek;
                    }
                    if (peek.y && lowestPeek.y && peek.y < lowestPeek.y) {
                        lowestPeek = peek;
                    }
                }
            });
            annotatedPeeks.push(highestPeek, lowestPeek);
        }
    }
    return annotatedPeeks;
};
export const SparklineCellRenderer = (props) => {
    const rowHeight = props.api.getRowNode((props.node.rowIndex || 0).toString())?.rowHeight;
    const extremes = useMemo(() => getExtremes(props?.colDef, props.api), [props.api, props.colDef]);
    const data = formatData(props.value, props.xAxisDisplayName, props.xAxisType, props.yAxisDisplayName, props.yAxisFormatKind);
    data.sort((a, b) => (a?.x || 0) - (b?.x || 0));
    const peeks = data?.filter((point) => point.id?.indexOf("peek") === 0).reverse();
    const annotatedPeeks = selectFirstHighestAndLowestPeeks(peeks);
    const annotations = annotatedPeeks.map((point) => ({ shapes: [{ point: point.id, r: Number(point.radius), type: "circle" }] }));
    const options = {
        annotations,
        chart: {
            spacing: [0, 0, 0, 0],
            styledMode: true,
            type: "line"
        },
        credits: { enabled: false },
        legend: { enabled: false },
        plotOptions: {
            line: { marker: { enabled: false } }
        },
        series: [
            {
                data,
                type: "line"
            }
        ],
        title: { text: "" },
        tooltip: {
            formatter: formatLabel,
            hideDelay: 0,
            outside: true
        },
        xAxis: {
            max: extremes.maxX,
            min: extremes.minX,
            visible: false
        },
        yAxis: {
            allowDecimals: true,
            labels: { enabled: false },
            max: extremes.maxY,
            min: extremes.minY,
            title: { text: null }
        }
    };
    return props?.node?.group || false
        ? React.createElement(React.Fragment, null)
        : React.createElement("div", { className: "sparklineCellRenderer", style: { height: `${String(rowHeight)}px` } },
            React.createElement(InsHighcharts, { options: options, uniqueKey: `${props.data?.id}-${props.colDef?.colId ? props.colDef?.colId : props.colDef?.field}` }));
};
